// Dialogflow (AnnaChatbot agent) answers every RIASEC question through its own intents:
//   riasec-start-yes / -no / -fallback       -> reply to Q1
//   riasec-question-N-yes / -no / -fallback  -> reply to QN (2-42); a fallback asks QN again
// Dialogflow sorts free text ("Oo", "Hindi", "disagree", ...) into these intents, so the intent
// name is the reliable source for both the question number and the yes/no answer.
export const RIASEC_TOTAL_QUESTIONS = 42;

// Returns { question, answer: 'yes' | 'no' | null } for a RIASEC intent (null answer = fallback), else null.
export const parseRiasecIntent = (displayName) => {
  const name = String(displayName || '').trim().toLowerCase();
  const start = name.match(/^riasec-start-(yes|no|fallback)$/);
  const numbered = name.match(/^riasec-question-(\d+)-(yes|no|fallback)$/);
  const reply = start ? start[1] : numbered?.[2];
  const question = start ? 1 : Number(numbered?.[1]);
  if (!reply || question < 1 || question > RIASEC_TOTAL_QUESTIONS) return null;
  return { question, answer: reply === 'fallback' ? null : reply };
};

export const looksLikeQuestion = (text) => {
  const lower = String(text || '').toLowerCase();
  return lower.includes('?') || lower.includes('do you like') || lower.includes('would you like');
};

// The question is the last text bubble that reads like one; Q15, Q21 and Q32 send an
// encouragement bubble ("We're halfway there!") before the next question.
export const findQuestionText = (fulfillmentMessages = []) => {
  const texts = fulfillmentMessages
    .map((msg) => msg?.text?.text?.[0])
    .filter((text) => typeof text === 'string' && looksLikeQuestion(text));
  return texts.length ? texts[texts.length - 1].trim() : '';
};
